import { render } from "./ErrorPayment.vue?vue&type=template&id=7dc85010&scoped=true&ts=true"
import script from "./ErrorPayment.vue?vue&type=script&lang=ts"
export * from "./ErrorPayment.vue?vue&type=script&lang=ts"

import "./ErrorPayment.vue?vue&type=style&index=0&id=7dc85010&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc85010"]])

export default __exports__